import { render, staticRenderFns } from "./Describe.vue?vue&type=template&id=684aadfe&scoped=true&"
import script from "./Describe.vue?vue&type=script&lang=js&"
export * from "./Describe.vue?vue&type=script&lang=js&"
import style0 from "./Describe.vue?vue&type=style&index=0&id=684aadfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684aadfe",
  null
  
)

export default component.exports